export default __webpack_public_path__ + "static/media/SlideSeven.8f21062d.png";